import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = "md",
}) => {
  const sizes = {
    sm: {
      switch: "w-9 h-6",
      dot: "h-[17px] w-[16px]",
      translate: "translate-x-4",
    },
    md: {
      switch: "w-11 h-6",
      dot: "h-5 w-5",
      translate: "translate-x-5",
    },
    lg: {
      switch: "w-14 h-7",
      dot: "h-6 w-6",
      translate: "translate-x-7",
    },
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`
        ${sizes[size].switch}
        ${checked ? "bg-primary" : "bg-gray-200"}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        relative inline-flex flex-shrink-0 rounded-full
        transition-colors duration-200 ease-in-out 
      `}
      style={{
        backgroundColor: checked ? "var(--primary)" : undefined,
        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0)",
      }}
    >
      <span
        className={`
          ${sizes[size].dot}
          ${checked ? sizes[size].translate : "translate-x-0.5"}
          pointer-events-none inline-block transform rounded-full 
          bg-white shadow-md ring-0 transition duration-200 ease-in-out
          absolute top-0.5 left-0.5
        `}
      />
    </button>
  );
};

export default Switch;
